import PropTypes from 'prop-types'

const Check = ({ width = 24, height = 24, color = '#4A4A4A', ...props }) => (
  <svg
    className="svg-icon"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 11.917 9.724 16.5 19 7.5"
    />
  </svg>
)

Check.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default Check
